/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Sample_LeadInputs */

const ja_playdata_sample_lead = /** @type {(inputs: Playdata_Sample_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以下、サンプルレポートをご覧いただけます。`)
};

const en_playdata_sample_lead = /** @type {(inputs: Playdata_Sample_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can view a sample report below.`)
};

/**
* | output |
* | --- |
* | "You can view a sample report below." |
*
* @param {Playdata_Sample_LeadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_sample_lead = /** @type {((inputs?: Playdata_Sample_LeadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Sample_LeadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_sample_lead(inputs)
	return en_playdata_sample_lead(inputs)
});